import React, { useState } from 'react'
import { CustomInput, CustomTable, HeaderComp } from '../../components'
import { Icon } from '@iconify/react';
import Template from '../../Template'
import { Col, Popconfirm, Radio, Row, Space, Typography } from 'antd';
import { DeleteOutlined, EyeFilled } from '@ant-design/icons';
import { useQuery } from '@apollo/client';
import { GET_STATUS } from '../../Graphql/queries/getQueries';



const Status = () => {
    const [page, setPage] = useState(1);
    const [open, setOpen] = useState(false);
    const [NewStatus, setNewStatus] = useState({})
    const emptyInput = () => setNewStatus({})

    const { error, loading, data } = useQuery(GET_STATUS, {
        variables: {
            page
        },
        fetchPolicy: 'network-only'
    })

    const dataSource = data?.Status.nodes.map((item) => {
        return {
            key: item.key,
            status: item.text,
            color: item.color,
            created_date: '2022-03-29 10:55:39',
        }
    })


    const columns = [
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',


        },
        {
            title: () => <Icon fontSize={27} icon="ic:baseline-color-lens" color="#b2b2b2" />,
            dataIndex: 'color',
            key: 'color',
            render: (_, record) => {
                return (
                    <>
                        <div style={{ background: `${record.color}`, width: 24, height: 24, borderRadius: '50%' }} ></div>
                    </>
                );
            },
        },
        {
            title: 'Created Date',
            dataIndex: 'created_date',
            key: 'created_date',
        },
        {
            title: 'Action',
            dataIndex: 'delete_status',
            key: 'delete_status',
            align: 'center',
            render: (_, record) => {
                return (
                    <div className='flex_center'>
                        <Icon icon="mdi:border-color" style={{ cursor: 'pointer' }} fontSize={25} color="#b2b2b2" onClick={() => onEdit(record)} />

                        <Popconfirm title="Are you sure to delete this user?" onConfirm={() => onDelete(record.key)}>
                            <DeleteOutlined style={{ color: 'red', fontSize: 20, marginLeft: 10 }} />
                        </Popconfirm>
                    </div>
                );
            },
        },

    ]

    const onDelete = (id) => {
        // setDataSource(prev => prev.filter(e => e.id !== id))
    }


    const onChange = (e) => {
        const { value, name } = e.target
        setNewStatus(prev => ({ ...prev, [name]: value }))
    }

    const onEdit = (record) => {
        console.log(record);
        const { color, status } = record
        setNewStatus({
            color,
            status
        })
        setOpen(true)

    }

    const popupContent = {
        title: 'Status',
        body: <PopupContent onChange={onChange} value={NewStatus} />
    }
    const onOk = () => {
        const newData = { ...NewStatus, 'Created Date': new Date() }
        console.log(newData)
    }
    return (
        <Template
            headerTitle={['Settings', 'status']}
        >
            <div className="item_comp" >
                <HeaderComp title="Status" btnType='popup' popupContnent={popupContent} onOk={onOk} isOpen={open} open={() => setOpen(true)} close={() => { emptyInput(); setOpen(false) }} />
                <CustomTable data={dataSource} columns={columns} pagination onPageChange={(page) => setPage(page)} loading={loading} total={data?.Status.total} />
            </div>
        </Template>
    )
}

export default Status

export const PopupContent = ({ onChange, value }) => {
    // const [value, setValue] = useState('#7A16FC');
    // const onChangeColor = (e) => {
    //     onChange(e)
    //     setValue(e.target.value);
    // };
    return (
        <>
            <div className='add_status flex_ver flex_center' style={{ width: '100%', gap: 10 }}  >
                <CustomInput type='text' value={value.status} name='status' label="Status name" onChange={onChange} />
                <Typography.Title level={5} style={{ alignSelf: 'flex-start', marginLeft: '55px' }}  >Color</Typography.Title>
                <Radio.Group onChange={onChange} value={value.color} name='color'>
                    <Row gutter={[10, 30]} style={{ marginLeft: '45px' }} >
                        <Col span={8} ><div className='radio_btn flex_center' style={{ background: "#7A16FC", }} ><Radio value={'#7A16FC'} defaultChecked></Radio></div> </Col>
                        <Col span={8} ><div className='radio_btn flex_center' style={{ background: "#00C7C0", }} ><Radio value={'#00C7C0'}></Radio></div> </Col>
                        <Col span={8} ><div className='radio_btn flex_center' style={{ background: "#FC7816", }} ><Radio value={"#FC7816"}></Radio></div> </Col>
                        <Col span={8} ><div className='radio_btn flex_center' style={{ background: "#CA321A", }} ><Radio value={'#CA321A'}></Radio></div> </Col>
                        <Col span={8} ><div className='radio_btn flex_center' style={{ background: "#FCB116", }} ><Radio value={'#FCB116'}></Radio></div> </Col>
                        <Col span={8} ><div className='radio_btn flex_center' style={{ background: "#00C771", }} ><Radio value={'#00C771'}></Radio></div> </Col>
                        <Col span={8} ><div className='radio_btn flex_center' style={{ background: "#1A37CA", }} ><Radio value={'#1A37CA'}></Radio></div> </Col>
                        <Col span={8} ><div className='radio_btn flex_center' style={{ background: "#AB008E", }} ><Radio value={'#AB008E'}></Radio></div> </Col>
                        <Col span={8} ><div className='radio_btn flex_center' style={{ background: "#3D97DA", }} ><Radio value={'#3D97DA'}></Radio></div> </Col>

                    </Row>
                </Radio.Group>
            </div>
        </>
    )
}